const pay = {
    handle_href: "http://pay.zhiweicloud.com/pay/orderPay.do", // 跳转支付平台处理页面
    // handle_href: "http://192.168.96.109:8089/pay/orderPay.do",
    // handle_href: "https://www.weihudashi.com/pay/orderPay.do",
    domain: "http://pay.zhuanbar.com:8084",
    pay_ways: [
        {
            // 支付方式
            id: 1,
            name: "支付宝",
            iframeShow: false, // 是否在iframe中显示
        },
        {
            id: 2,
            name: "微信",
            iframeShow: true,
        },
    ],
    getRedirectUrl(payData, first, second) {
        first = first || "";
        second = second || "";
        first = first === "" ? "" : first + "-";
        second = second === "" ? "" : second + "-";
        const redirect_href =
            `${this.handle_href}?pay_way=${payData.paytype}&sign=${
                payData.sign
            }&timestamp=${payData.timestamp}&WIDout_trade_no=${
                payData.orderNo
            }&WIDtotal_amount=${payData.money}&passport_name=${
                payData.passport_name
            }&WIDsubject=` +
            encodeURIComponent(`${first}${second}${payData.goods_name}`) +
            "&WIDbody=" +
            encodeURIComponent(payData.goods_name) +
            "&WIDPayType=1&platform=80&redirect=whds_vip";
        return redirect_href;
    },
};
export default pay;
